import useGaugeValue from './hooks/useGaugeValue';

import './styles.scss';
import { useNormalizeAssetPath } from '../../../features/base/hooks/useBase';
import { useWindowDimensions } from 'festo-react-ui-kit/lib/utils/utils';
import { getHighlightedValue } from '../utils';
import { FilterValueKey } from '../../../features/filter/utils';
import { useAppSelector } from '../../../app/hooks';

interface Props {
  value: number;
  isFirstGauge?: boolean;
}

const Gauge: React.FC<Props> = ({ value = 0, isFirstGauge }) => {
  const values = useAppSelector((state) => state.filter.filtersValue);
  const { width } = useWindowDimensions();
  const isGaugeOnMobileNeeded = width < 1440;
  const isLowerThan1024px = width < 1024;
  const { RotationValues } = useGaugeValue({ value, isMobile: isGaugeOnMobileNeeded });
  const normalizeAssetPath = useNormalizeAssetPath();
  const path = 'assets/';

  const isHighlighted = getHighlightedValue({
    value: values[FilterValueKey.CALCULATION_RESULT].toString(),
    calculationValue: isFirstGauge ? 'P1' : 'P2',
  });

  const pressureText = `bar (P${isFirstGauge ? '₁' : '₂'})`;

  return (
    <>
      <div className="gauge__container">
        <div className="gauge__container">
          <img src={normalizeAssetPath(`${path}festo-gauge.png`)} alt="Gauge" className="gauge__image" />
          <div className="gauge__pointer--container" style={{ transform: RotationValues.GAUGE }}>
            <img src={normalizeAssetPath(`${path}Blue-arrow.svg`)} alt="arrow hand gauge" className="gauge__pointer" />
            <img
              src={normalizeAssetPath(`${path}Grey-arrow.svg`)}
              alt="arrow hand shadow gauge"
              className="gauge__pointer--shadow"
              style={{ top: RotationValues.SHADOW }}
            />
          </div>
        </div>
        <img
          src={normalizeAssetPath(isLowerThan1024px ? `${path}grey-horizontal-line.png` : `${path}grey-line.png`)}
          className="gauge__connection-tube"
          alt="black line connecting gauges"
        />
        <span className={`gauge__pressure-box ${isHighlighted ? 'pd-4' : ''}`}>
          <span className={isHighlighted ? 'highlight-value' : ''}>{value}</span> {` ${pressureText}`}
        </span>
      </div>
    </>
  );
};

export default Gauge;
